import track from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';

export interface DeletePortfolioModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const DeletePortfolioModal = ({
  onClose,
  onConfirm,
}: DeletePortfolioModalProps) => (
  <Modal
    title="Delete Portfolio"
    onSecondaryClick={onClose}
    onPrimaryClick={onConfirm}
    secondaryLabel="Cancel"
    primaryLabel="Delete"
  >
    {`Are you sure you want to delete your portfolio?`}
  </Modal>
);

export default track({
  type: 'track',
  subject: 'DeletePortfolioModal',
})(DeletePortfolioModal);
